import { Trans } from '@lingui/macro';
import { Link } from 'react-router-dom';

import AuthLayout from '@/UI/auth-layout';

const Page404 = () => {
    return (
        <AuthLayout
            header={<span className="gradient-text text-7xl m-0">404</span>}
            subHeader={
                <>
                    <Trans>this link is not correct</Trans>!
                </>
            }>
            <Link className="btn-link" to="/">
                <Trans>Go Home</Trans>
            </Link>
        </AuthLayout>
    );
};

export default Page404;
